export interface IWebHook {
  key: string;
  url: string;
}
